import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/pro-light-svg-icons/faCalendar';
import { TypedMemo } from '../../common/types';
import { servicesPanelMessages as m } from './servicesPanelMessages';
import { withBrandWord } from '../components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for ServicesPanel; each part uses its own slice of it */
import styles from './ServicesPanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The line of an unreleased song (design d2): on release day Music24 fills the links. */
const ServicesPanelLeadComponent: React.FC<{ title: string; releaseDate: string | null }> = ({
  title,
  releaseDate,
}) => {
  const intl = useIntl();
  const day =
    releaseDate === null
      ? null
      : intl.formatDate(releaseDate.slice(0, 10), {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          timeZone: 'UTC',
        });
  return (
    <div className={styles.lead}>
      <FontAwesomeIcon icon={faCalendar} />
      <span>
        {day === null
          ? withBrandWord(intl.formatMessage(m.unreleasedLeadNoDate, { title }))
          : withBrandWord(intl.formatMessage(m.unreleasedLead, { title, date: day }))}
      </span>
    </div>
  );
};

export const ServicesPanelLead = TypedMemo(ServicesPanelLeadComponent);
